export enum OfferAlertTimelineActionEnum {
  OFFER_ALERT_CREATED = "offer_alert_created",
  OFFER_ALERT_ALERT = "offer_alert_alert",
  OFFER_ALERT_EXPIRED = "offer_alert_expired",
  OFFER_ALERT_DELETED = "offer_alert_deleted",
}
